export const SIGNUP_URL = "https://manage.app.preset.io/starter-registration/"
export const API_DOCS_URL = "https://api-docs.preset.io/"
export const CONTACT_URL = "/contact-sales/"
export const PRODUCT_URL = "/product/"
export const EMBEDDED_DASHBOARDS_URL = "/embedded-dashboards/"
export const ACCESS_EMBEDDED_URL = "/access-embedded/"
export const APACHE_SUPERSET_URL = "/apache-superset/"
export const TRUST_AND_SECURITY_URL = "/trust-and-security/"
export const CUSTOMERS_URL = "/customers/"
export const PRICING_URL = "/pricing/"
export const API_URL = "/api/"
export const UC_INTERNAL_BI_URL = "/use-cases/internal-bi/"
export const UC_INTERNAL_TOOLING_URL = "/use-cases/internal-tooling/"
export const UC_CUSTOMER_APPS_URL = "/use-cases/customer-apps/"
